export default {
  common: {
    nav: {
      home: "Accueil",
      find_offer_help: "Trouver / Offrir de l'aide",
      celebrate: "Célébrer une vie",
      family_tree: "Arbre généalogique",
      events: "Événements",
      civic_reports: "Rapports civiques",
      neighborhood_pulse: "Pouls du quartier",
      weather: "Météo",
      nature: "Nature",
      marketplace: "Marché",
      news: "Actualités",
      causes: "Causes",
      more: "Plus",
    },
    header: { sign_in: "Connexion", join: "Rejoindre Social Pulse", language: "Langue", search: "Rechercher" },
    tagline: "Connecter les communautés · Autonomiser les vies · Bâtir le capital social",
    locality: {
      viewing_from: "Vous consultez depuis",
      help_improve: "Aidez-nous à améliorer votre localisation",
      filter_by_country: "Filtrer par pays",
      change: "Modifier",
      set_your_location: "Définir votre lieu",
      set_your_location_hint: "— appuyez pour personnaliser",
    },
    actions: {
      submit_cause: "Soumettre une cause / demande",
      make_donation: "Soutenez les initiatives mondiales de Social Pulse — Faites un don",
      browse_all: "Parcourir toutes les sections",
    },
    news: {
      title: "Votre briefing quotidien.",
      submit_news: "Soumettre une actualité",
      archive: "Archives",
      weather_nature: "Météo & Nature",
      play_briefing: "Lire le briefing quotidien",
      play_briefing_hint: "Écoutez les {{count}} meilleures actualités · ~{{minutes}} min · dans votre langue",
      read_original: "Lire l'original",
      view_brief: "Voir le résumé",
      also_reported_by: "Aussi rapporté par :",
      translate: "Traduire",
      listen: "Écouter",
      stop: "Arrêter",
    },
  },
};
